import N, { createRef as Ur, Component as Jr } from "react";
var I = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Pt = { exports: {} };
(function(e, t) {
  var n = 200, i = "__lodash_hash_undefined__", s = 9007199254740991, a = "[object Arguments]", u = "[object Array]", f = "[object Boolean]", h = "[object Date]", l = "[object Error]", g = "[object Function]", T = "[object GeneratorFunction]", L = "[object Map]", k = "[object Number]", H = "[object Object]", it = "[object Promise]", W = "[object RegExp]", S = "[object Set]", Y = "[object String]", ot = "[object Symbol]", K = "[object WeakMap]", B = "[object ArrayBuffer]", m = "[object DataView]", E = "[object Float32Array]", R = "[object Float64Array]", X = "[object Int8Array]", Jt = "[object Int16Array]", Ht = "[object Int32Array]", Wt = "[object Uint8Array]", Yt = "[object Uint8ClampedArray]", Kt = "[object Uint16Array]", Xt = "[object Uint32Array]", An = /[\\^$.*+?()[\]{}|]/g, Tn = /\w*$/, On = /^\[object .+?Constructor\]$/, En = /^(?:0|[1-9]\d*)$/, _ = {};
  _[a] = _[u] = _[B] = _[m] = _[f] = _[h] = _[E] = _[R] = _[X] = _[Jt] = _[Ht] = _[L] = _[k] = _[H] = _[W] = _[S] = _[Y] = _[ot] = _[Wt] = _[Yt] = _[Kt] = _[Xt] = !0, _[l] = _[g] = _[K] = !1;
  var Sn = typeof I == "object" && I && I.Object === Object && I, Mn = typeof self == "object" && self && self.Object === Object && self, M = Sn || Mn || Function("return this")(), Zt = t && !t.nodeType && t, te = Zt && !0 && e && !e.nodeType && e, xn = te && te.exports === Zt;
  function Cn(r, o) {
    return r.set(o[0], o[1]), r;
  }
  function Ln(r, o) {
    return r.add(o), r;
  }
  function Rn(r, o) {
    for (var c = -1, d = r ? r.length : 0; ++c < d && o(r[c], c, r) !== !1; )
      ;
    return r;
  }
  function jn(r, o) {
    for (var c = -1, d = o.length, y = r.length; ++c < d; )
      r[y + c] = o[c];
    return r;
  }
  function ee(r, o, c, d) {
    for (var y = -1, w = r ? r.length : 0; ++y < w; )
      c = o(c, r[y], y, r);
    return c;
  }
  function In(r, o) {
    for (var c = -1, d = Array(r); ++c < r; )
      d[c] = o(c);
    return d;
  }
  function Pn(r, o) {
    return r == null ? void 0 : r[o];
  }
  function ne(r) {
    var o = !1;
    if (r != null && typeof r.toString != "function")
      try {
        o = !!(r + "");
      } catch {
      }
    return o;
  }
  function re(r) {
    var o = -1, c = Array(r.size);
    return r.forEach(function(d, y) {
      c[++o] = [y, d];
    }), c;
  }
  function bt(r, o) {
    return function(c) {
      return r(o(c));
    };
  }
  function ie(r) {
    var o = -1, c = Array(r.size);
    return r.forEach(function(d) {
      c[++o] = d;
    }), c;
  }
  var $n = Array.prototype, Fn = Function.prototype, st = Object.prototype, At = M["__core-js_shared__"], oe = function() {
    var r = /[^.]+$/.exec(At && At.keys && At.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }(), se = Fn.toString, j = st.hasOwnProperty, at = st.toString, Vn = RegExp(
    "^" + se.call(j).replace(An, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), ae = xn ? M.Buffer : void 0, ce = M.Symbol, ue = M.Uint8Array, Qn = bt(Object.getPrototypeOf, Object), kn = Object.create, Bn = st.propertyIsEnumerable, Gn = $n.splice, le = Object.getOwnPropertySymbols, Dn = ae ? ae.isBuffer : void 0, qn = bt(Object.keys, Object), Tt = q(M, "DataView"), Z = q(M, "Map"), Ot = q(M, "Promise"), Et = q(M, "Set"), St = q(M, "WeakMap"), tt = q(Object, "create"), zn = V(Tt), Nn = V(Z), Un = V(Ot), Jn = V(Et), Hn = V(St), fe = ce ? ce.prototype : void 0, de = fe ? fe.valueOf : void 0;
  function $(r) {
    var o = -1, c = r ? r.length : 0;
    for (this.clear(); ++o < c; ) {
      var d = r[o];
      this.set(d[0], d[1]);
    }
  }
  function Wn() {
    this.__data__ = tt ? tt(null) : {};
  }
  function Yn(r) {
    return this.has(r) && delete this.__data__[r];
  }
  function Kn(r) {
    var o = this.__data__;
    if (tt) {
      var c = o[r];
      return c === i ? void 0 : c;
    }
    return j.call(o, r) ? o[r] : void 0;
  }
  function Xn(r) {
    var o = this.__data__;
    return tt ? o[r] !== void 0 : j.call(o, r);
  }
  function Zn(r, o) {
    var c = this.__data__;
    return c[r] = tt && o === void 0 ? i : o, this;
  }
  $.prototype.clear = Wn, $.prototype.delete = Yn, $.prototype.get = Kn, $.prototype.has = Xn, $.prototype.set = Zn;
  function x(r) {
    var o = -1, c = r ? r.length : 0;
    for (this.clear(); ++o < c; ) {
      var d = r[o];
      this.set(d[0], d[1]);
    }
  }
  function tr() {
    this.__data__ = [];
  }
  function er(r) {
    var o = this.__data__, c = ct(o, r);
    if (c < 0)
      return !1;
    var d = o.length - 1;
    return c == d ? o.pop() : Gn.call(o, c, 1), !0;
  }
  function nr(r) {
    var o = this.__data__, c = ct(o, r);
    return c < 0 ? void 0 : o[c][1];
  }
  function rr(r) {
    return ct(this.__data__, r) > -1;
  }
  function ir(r, o) {
    var c = this.__data__, d = ct(c, r);
    return d < 0 ? c.push([r, o]) : c[d][1] = o, this;
  }
  x.prototype.clear = tr, x.prototype.delete = er, x.prototype.get = nr, x.prototype.has = rr, x.prototype.set = ir;
  function G(r) {
    var o = -1, c = r ? r.length : 0;
    for (this.clear(); ++o < c; ) {
      var d = r[o];
      this.set(d[0], d[1]);
    }
  }
  function or() {
    this.__data__ = {
      hash: new $(),
      map: new (Z || x)(),
      string: new $()
    };
  }
  function sr(r) {
    return ut(this, r).delete(r);
  }
  function ar(r) {
    return ut(this, r).get(r);
  }
  function cr(r) {
    return ut(this, r).has(r);
  }
  function ur(r, o) {
    return ut(this, r).set(r, o), this;
  }
  G.prototype.clear = or, G.prototype.delete = sr, G.prototype.get = ar, G.prototype.has = cr, G.prototype.set = ur;
  function D(r) {
    this.__data__ = new x(r);
  }
  function lr() {
    this.__data__ = new x();
  }
  function fr(r) {
    return this.__data__.delete(r);
  }
  function dr(r) {
    return this.__data__.get(r);
  }
  function hr(r) {
    return this.__data__.has(r);
  }
  function pr(r, o) {
    var c = this.__data__;
    if (c instanceof x) {
      var d = c.__data__;
      if (!Z || d.length < n - 1)
        return d.push([r, o]), this;
      c = this.__data__ = new G(d);
    }
    return c.set(r, o), this;
  }
  D.prototype.clear = lr, D.prototype.delete = fr, D.prototype.get = dr, D.prototype.has = hr, D.prototype.set = pr;
  function gr(r, o) {
    var c = Ct(r) || kr(r) ? In(r.length, String) : [], d = c.length, y = !!d;
    for (var w in r)
      j.call(r, w) && !(y && (w == "length" || $r(w, d))) && c.push(w);
    return c;
  }
  function he(r, o, c) {
    var d = r[o];
    (!(j.call(r, o) && me(d, c)) || c === void 0 && !(o in r)) && (r[o] = c);
  }
  function ct(r, o) {
    for (var c = r.length; c--; )
      if (me(r[c][0], o))
        return c;
    return -1;
  }
  function _r(r, o) {
    return r && pe(o, Lt(o), r);
  }
  function Mt(r, o, c, d, y, w, C) {
    var b;
    if (d && (b = w ? d(r, y, w, C) : d(r)), b !== void 0)
      return b;
    if (!lt(r))
      return r;
    var we = Ct(r);
    if (we) {
      if (b = jr(r), !o)
        return Cr(r, b);
    } else {
      var z = F(r), be = z == g || z == T;
      if (Gr(r))
        return Ar(r, o);
      if (z == H || z == a || be && !w) {
        if (ne(r))
          return w ? r : {};
        if (b = Ir(be ? {} : r), !o)
          return Lr(r, _r(b, r));
      } else {
        if (!_[z])
          return w ? r : {};
        b = Pr(r, z, Mt, o);
      }
    }
    C || (C = new D());
    var Ae = C.get(r);
    if (Ae)
      return Ae;
    if (C.set(r, b), !we)
      var Te = c ? Rr(r) : Lt(r);
    return Rn(Te || r, function(Rt, ft) {
      Te && (ft = Rt, Rt = r[ft]), he(b, ft, Mt(Rt, o, c, d, ft, r, C));
    }), b;
  }
  function mr(r) {
    return lt(r) ? kn(r) : {};
  }
  function vr(r, o, c) {
    var d = o(r);
    return Ct(r) ? d : jn(d, c(r));
  }
  function yr(r) {
    return at.call(r);
  }
  function wr(r) {
    if (!lt(r) || Vr(r))
      return !1;
    var o = ye(r) || ne(r) ? Vn : On;
    return o.test(V(r));
  }
  function br(r) {
    if (!_e(r))
      return qn(r);
    var o = [];
    for (var c in Object(r))
      j.call(r, c) && c != "constructor" && o.push(c);
    return o;
  }
  function Ar(r, o) {
    if (o)
      return r.slice();
    var c = new r.constructor(r.length);
    return r.copy(c), c;
  }
  function xt(r) {
    var o = new r.constructor(r.byteLength);
    return new ue(o).set(new ue(r)), o;
  }
  function Tr(r, o) {
    var c = o ? xt(r.buffer) : r.buffer;
    return new r.constructor(c, r.byteOffset, r.byteLength);
  }
  function Or(r, o, c) {
    var d = o ? c(re(r), !0) : re(r);
    return ee(d, Cn, new r.constructor());
  }
  function Er(r) {
    var o = new r.constructor(r.source, Tn.exec(r));
    return o.lastIndex = r.lastIndex, o;
  }
  function Sr(r, o, c) {
    var d = o ? c(ie(r), !0) : ie(r);
    return ee(d, Ln, new r.constructor());
  }
  function Mr(r) {
    return de ? Object(de.call(r)) : {};
  }
  function xr(r, o) {
    var c = o ? xt(r.buffer) : r.buffer;
    return new r.constructor(c, r.byteOffset, r.length);
  }
  function Cr(r, o) {
    var c = -1, d = r.length;
    for (o || (o = Array(d)); ++c < d; )
      o[c] = r[c];
    return o;
  }
  function pe(r, o, c, d) {
    c || (c = {});
    for (var y = -1, w = o.length; ++y < w; ) {
      var C = o[y], b = void 0;
      he(c, C, b === void 0 ? r[C] : b);
    }
    return c;
  }
  function Lr(r, o) {
    return pe(r, ge(r), o);
  }
  function Rr(r) {
    return vr(r, Lt, ge);
  }
  function ut(r, o) {
    var c = r.__data__;
    return Fr(o) ? c[typeof o == "string" ? "string" : "hash"] : c.map;
  }
  function q(r, o) {
    var c = Pn(r, o);
    return wr(c) ? c : void 0;
  }
  var ge = le ? bt(le, Object) : zr, F = yr;
  (Tt && F(new Tt(new ArrayBuffer(1))) != m || Z && F(new Z()) != L || Ot && F(Ot.resolve()) != it || Et && F(new Et()) != S || St && F(new St()) != K) && (F = function(r) {
    var o = at.call(r), c = o == H ? r.constructor : void 0, d = c ? V(c) : void 0;
    if (d)
      switch (d) {
        case zn:
          return m;
        case Nn:
          return L;
        case Un:
          return it;
        case Jn:
          return S;
        case Hn:
          return K;
      }
    return o;
  });
  function jr(r) {
    var o = r.length, c = r.constructor(o);
    return o && typeof r[0] == "string" && j.call(r, "index") && (c.index = r.index, c.input = r.input), c;
  }
  function Ir(r) {
    return typeof r.constructor == "function" && !_e(r) ? mr(Qn(r)) : {};
  }
  function Pr(r, o, c, d) {
    var y = r.constructor;
    switch (o) {
      case B:
        return xt(r);
      case f:
      case h:
        return new y(+r);
      case m:
        return Tr(r, d);
      case E:
      case R:
      case X:
      case Jt:
      case Ht:
      case Wt:
      case Yt:
      case Kt:
      case Xt:
        return xr(r, d);
      case L:
        return Or(r, d, c);
      case k:
      case Y:
        return new y(r);
      case W:
        return Er(r);
      case S:
        return Sr(r, d, c);
      case ot:
        return Mr(r);
    }
  }
  function $r(r, o) {
    return o = o ?? s, !!o && (typeof r == "number" || En.test(r)) && r > -1 && r % 1 == 0 && r < o;
  }
  function Fr(r) {
    var o = typeof r;
    return o == "string" || o == "number" || o == "symbol" || o == "boolean" ? r !== "__proto__" : r === null;
  }
  function Vr(r) {
    return !!oe && oe in r;
  }
  function _e(r) {
    var o = r && r.constructor, c = typeof o == "function" && o.prototype || st;
    return r === c;
  }
  function V(r) {
    if (r != null) {
      try {
        return se.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  function Qr(r) {
    return Mt(r, !0, !0);
  }
  function me(r, o) {
    return r === o || r !== r && o !== o;
  }
  function kr(r) {
    return Br(r) && j.call(r, "callee") && (!Bn.call(r, "callee") || at.call(r) == a);
  }
  var Ct = Array.isArray;
  function ve(r) {
    return r != null && Dr(r.length) && !ye(r);
  }
  function Br(r) {
    return qr(r) && ve(r);
  }
  var Gr = Dn || Nr;
  function ye(r) {
    var o = lt(r) ? at.call(r) : "";
    return o == g || o == T;
  }
  function Dr(r) {
    return typeof r == "number" && r > -1 && r % 1 == 0 && r <= s;
  }
  function lt(r) {
    var o = typeof r;
    return !!r && (o == "object" || o == "function");
  }
  function qr(r) {
    return !!r && typeof r == "object";
  }
  function Lt(r) {
    return ve(r) ? gr(r) : br(r);
  }
  function zr() {
    return [];
  }
  function Nr() {
    return !1;
  }
  e.exports = Qr;
})(Pt, Pt.exports);
var P = Pt.exports, et = function() {
  return et = Object.assign || function(t) {
    for (var n, i = 1, s = arguments.length; i < s; i++) {
      n = arguments[i];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, et.apply(this, arguments);
};
function Hr(e, t, n, i) {
  function s(a) {
    return a instanceof n ? a : new n(function(u) {
      u(a);
    });
  }
  return new (n || (n = Promise))(function(a, u) {
    function f(g) {
      try {
        l(i.next(g));
      } catch (T) {
        u(T);
      }
    }
    function h(g) {
      try {
        l(i.throw(g));
      } catch (T) {
        u(T);
      }
    }
    function l(g) {
      g.done ? a(g.value) : s(g.value).then(f, h);
    }
    l((i = i.apply(e, [])).next());
  });
}
function Wr(e, t) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, i, s, a, u = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return u.next = f(0), u.throw = f(1), u.return = f(2), typeof Symbol == "function" && (u[Symbol.iterator] = function() {
    return this;
  }), u;
  function f(l) {
    return function(g) {
      return h([l, g]);
    };
  }
  function h(l) {
    if (i) throw new TypeError("Generator is already executing.");
    for (; u && (u = 0, l[0] && (n = 0)), n; ) try {
      if (i = 1, s && (a = l[0] & 2 ? s.return : l[0] ? s.throw || ((a = s.return) && a.call(s), 0) : s.next) && !(a = a.call(s, l[1])).done) return a;
      switch (s = 0, a && (l = [l[0] & 2, a.value]), l[0]) {
        case 0:
        case 1:
          a = l;
          break;
        case 4:
          return n.label++, { value: l[1], done: !1 };
        case 5:
          n.label++, s = l[1], l = [0];
          continue;
        case 7:
          l = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            n = 0;
            continue;
          }
          if (l[0] === 3 && (!a || l[1] > a[0] && l[1] < a[3])) {
            n.label = l[1];
            break;
          }
          if (l[0] === 6 && n.label < a[1]) {
            n.label = a[1], a = l;
            break;
          }
          if (a && n.label < a[2]) {
            n.label = a[2], n.ops.push(l);
            break;
          }
          a[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      l = t.call(e, n);
    } catch (g) {
      l = [6, g], s = 0;
    } finally {
      i = a = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function dt(e, t, n, i, s) {
  return Hr(this, void 0, void 0, function() {
    var a, u;
    return Wr(this, function(f) {
      switch (f.label) {
        case 0:
          if (n === void 0)
            return [
              2
              /*return*/
            ];
          u = 0, f.label = 1;
        case 1:
          return u < n.length ? [4, n[u](e, t, i, s, n)] : [3, 4];
        case 2:
          if (a = f.sent(), a === "canceled")
            return [3, 4];
          f.label = 3;
        case 3:
          return u++, [3, 1];
        case 4:
          return a !== "canceled" ? [2, a] : [
            2
            /*return*/
          ];
      }
    });
  });
}
var ht = function(e, t) {
  return t === void 0 && (t = {}), e ? {
    trackedAnalytics: et({ sdkCode: e.sdkCode, sdkSemver: e.sdkSemver, techVersion: e.techVersion }, t)
  } : null;
}, Yr = (
  /** @class */
  function() {
    function e(t, n, i, s) {
      var a = this;
      this.isMounted = !0, this.imgElement = t, this.htmlPluginState = { cleanupCallbacks: [], pluginEventSubscription: [] };
      var u = P(n);
      dt(t, u, i, this.htmlPluginState, s).then(function(f) {
        if (a.isMounted) {
          a.htmlPluginState.pluginEventSubscription.forEach(function(l) {
            l();
          });
          var h = ht(s, f);
          a.imgElement.setAttribute("src", u.toURL(h));
        }
      });
    }
    return e.prototype.update = function(t, n, i) {
      var s = this, a = P(t);
      dt(this.imgElement, a, n, this.htmlPluginState).then(function(u) {
        if (s.isMounted) {
          var f = ht(i, u);
          s.imgElement.setAttribute("src", a.toURL(f));
        }
      });
    }, e.prototype.unmount = function() {
      this.isMounted = !1;
    }, e;
  }()
);
class v {
  /**
   *
   * @param {QualifierValue | QualifierValue[] | any[] | string | number}qualifierValue
   */
  constructor(t) {
    this.values = [], this.delimiter = ":", this.hasValue(t) && this.addValue(t);
  }
  /**
   * @description Joins the provided values with the provided delimiter
   */
  toString() {
    return this.values.join(this.delimiter);
  }
  /**
   * @description Checks if the provided argument has a value
   * @param {any} v
   * @private
   * @return {boolean}
   */
  hasValue(t) {
    return typeof t < "u" && t !== null && t !== "";
  }
  /**
   * @desc Adds a value for the this qualifier instance
   * @param {any} value
   * @return {this}
   */
  addValue(t) {
    return Array.isArray(t) ? this.values = this.values.concat(t) : this.values.push(t), this.values = this.values.filter((n) => this.hasValue(n)), this;
  }
  /**
   * @description Sets the delimiter for this instance
   * @param delimiter
   */
  setDelimiter(t) {
    return this.delimiter = t, this;
  }
}
class Kr extends Error {
  constructor(t = "Unsupported") {
    super(t);
  }
}
function Qt(e) {
  return new Kr(e);
}
function Xr() {
  return this._qualifierModel || { error: Qt(`unsupported qualifier ${this.constructor.name}`) };
}
class Zr {
  constructor() {
    this._qualifierModel = {};
  }
  toJson() {
    return Xr.apply(this);
  }
}
class p extends Zr {
  constructor(t, n) {
    super(), this.delimiter = "_", this.key = t, n instanceof v ? this.qualifierValue = n : (this.qualifierValue = new v(), this.qualifierValue.addValue(n));
  }
  toString() {
    const { key: t, delimiter: n, qualifierValue: i } = this;
    return `${t}${n}${i.toString()}`;
  }
  addValue(t) {
    return this.qualifierValue.addValue(t), this;
  }
}
class O extends p {
  constructor(t, n) {
    let i;
    n ? i = new v([t, `${n}`]).setDelimiter(":") : i = t, super("fl", i), this.flagValue = n;
  }
  toString() {
    return super.toString().replace(/\./g, "%2E");
  }
  getFlagValue() {
    return this.flagValue;
  }
}
function ti(e, t) {
  const n = Array.from(e.entries());
  return t.forEach((i) => {
    n.push(["fl", i]);
  }), n.sort().map((i) => i[1]);
}
function ei() {
  var e, t, n;
  const i = this._actionModel && Object.keys(this._actionModel).length, s = (n = (t = (e = this._actionModel) === null || e === void 0 ? void 0 : e.source) === null || t === void 0 ? void 0 : t.transformation) === null || n === void 0 ? void 0 : n.error;
  return s && s instanceof Error ? { error: s } : i ? this._actionModel : { error: Qt(`unsupported action ${this.constructor.name}`) };
}
class ni {
  constructor() {
    this._actionModel = {};
  }
  toJson() {
    return ei.apply(this);
  }
}
class A extends ni {
  constructor() {
    super(...arguments), this.qualifiers = /* @__PURE__ */ new Map(), this.flags = [], this.delimiter = ",", this.actionTag = "";
  }
  prepareQualifiers() {
  }
  /**
   * @description Returns the custom name tag that was given to this action
   * @return {string}
   */
  getActionTag() {
    return this.actionTag;
  }
  /**
   * @description Sets the custom name tag for this action
   * @return {this}
   */
  setActionTag(t) {
    return this.actionTag = t, this;
  }
  /**
   * @description Calls toString() on all child qualifiers (implicitly by using .join()).
   * @return {string}
   */
  toString() {
    return this.prepareQualifiers(), ti(this.qualifiers, this.flags).join(this.delimiter);
  }
  /**
   * @description Adds the parameter to the action.
   * @param {SDK.Qualifier} qualifier
   * @return {this}
   */
  addQualifier(t) {
    if (typeof t == "string") {
      const [n, i] = t.toLowerCase().split("_");
      n === "fl" ? this.flags.push(new O(i)) : this.qualifiers.set(n, new p(n, i));
    } else
      this.qualifiers.set(t.key, t);
    return this;
  }
  /**
   * @description Adds a flag to the current action.
   * @param {Qualifiers.Flag} flag
   * @return {this}
   */
  addFlag(t) {
    return typeof t == "string" ? this.flags.push(new O(t)) : t instanceof O && this.flags.push(t), this;
  }
  addValueToQualifier(t, n) {
    return this.qualifiers.get(t).addValue(n), this;
  }
}
class kt extends A {
  constructor(t) {
    super(), this.regionType = t, this._actionModel.regionType = t;
  }
}
class gt extends kt {
  constructor() {
    super("custom");
  }
  /**
   * @description The x position in pixels.
   * @param {number | string} x
   */
  x(t) {
    return this._actionModel.x = t, this.addQualifier(new p("x", t)), this;
  }
  /**
   * @description The y position in pixels.
   * @param {number | string} y
   */
  y(t) {
    return this._actionModel.y = t, this.addQualifier(new p("y", t)), this;
  }
  /**
   * @description The width of the region in pixels.
   * @param {number | string} width
   */
  width(t) {
    return this._actionModel.width = t, this.addQualifier(new p("w", t)), this;
  }
  /**
   * @description The height of the region in pixels.
   * @param {number | string} height
   */
  height(t) {
    return this._actionModel.height = t, this.addQualifier(new p("h", t)), this;
  }
  static fromJson(t) {
    const n = new gt();
    return t.width && n.width(t.width), t.height && n.height(t.height), t.x && n.x(t.x), t.y && n.y(t.y), n;
  }
}
function ri() {
  return new gt();
}
function Fe() {
  return new kt("faces");
}
function ii() {
  return new kt("ocr_text");
}
class oi extends A {
  constructor(t) {
    super(), this._actionModel = {}, this._strength = t, this._actionModel.actionType = "blur", this._actionModel.strength = t;
  }
  /**
   * @description Specifies the region to blur.
   * @param {NamedRegion} blurRegion
   */
  region(t) {
    return this._region = t, this._actionModel.region = t.toJson(), this;
  }
  /**
   * @description Sets the strength of the blur effect.
   * @param {number | string} strength
   */
  strength(t) {
    return this._strength = t, this._actionModel.strength = t, this;
  }
  prepareQualifiers() {
    const t = this._strength ? `:${this._strength}` : "";
    "_region" in this ? (this._region.qualifiers.forEach((i) => this.addQualifier(i)), this._region.regionType === "custom" && this.addQualifier(new p("e", `blur_region${t}`)), this._region.regionType === "ocr_text" && (this.addQualifier(new p("e", `blur_region${t}`)), this.addQualifier(new p("g", "ocr_text"))), this._region.regionType === "faces" && this.addQualifier(new p("e", `blur_faces${t}`))) : this.addQualifier(new p("e", `blur${t}`));
  }
  static fromJson(t) {
    const { strength: n, region: i } = t, s = new this(n);
    return n && s.strength(n), i && i.regionType === "faces" && s.region(Fe()), i && i.regionType === "ocr_text" && s.region(ii()), i && i.regionType === "custom" && s.region(gt.fromJson(i)), s;
  }
}
function Q(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[e[n]] = n;
  }), t;
}
const Ve = {
  limitFit: "limit",
  limitFill: "lfill",
  minimumFit: "mfit",
  thumbnail: "thumb",
  limitPad: "lpad",
  minimumPad: "mpad",
  autoPad: "auto_pad"
}, si = {
  colorSpace: "cs",
  dpr: "dpr",
  density: "dn",
  defaultImage: "d",
  format: "f",
  quality: "q"
}, Qe = {
  redEye: "redeye",
  advancedRedEye: "adv_redeye",
  oilPaint: "oil_paint",
  unsharpMask: "unsharp_mask",
  makeTransparent: "make_transparent",
  generativeRestore: "gen_restore",
  upscale: "upscale"
}, ke = {
  autoBest: "auto:best",
  autoEco: "auto:eco",
  autoGood: "auto:good",
  autoLow: "auto:low",
  jpegminiHigh: "jpegmini:1",
  jpegminiMedium: "jpegmini:2",
  jpegminiBest: "jpegmini:0"
}, ai = {
  fullHd: "full_hd",
  fullHdWifi: "full_hd_wifi",
  fullHdLean: "full_hd_lean",
  hdLean: "hd_lean"
}, Be = {
  444: "CHROMA_444",
  420: "CHROMA_420"
}, ci = {
  noCmyk: "no_cmyk",
  keepCmyk: "keep_cmyk",
  tinySrgb: "tinysrgb",
  srgbTrueColor: "srgb:truecolor"
}, ui = Q(Be);
Q(ci);
const li = Q(Ve), fi = Q(si), Ge = Q(Qe);
Q(ke);
Q(ai);
class De extends A {
  constructor(t, n) {
    super(), this._actionModel = {}, this._actionModel.actionType = Ge[t] || t;
    const i = this.createEffectQualifier(t, n);
    this.addQualifier(i);
  }
  createEffectQualifier(t, n) {
    let i;
    return n ? i = new v([t, `${n}`]).setDelimiter(":") : i = new v(t), new p("e", i);
  }
  static fromJson(t) {
    const { actionType: n, level: i, strength: s } = t, a = Qe[n] || n;
    return new this(a, i || s);
  }
}
class di extends De {
  constructor(t, n) {
    super(t, n), this.LEVEL_NAME = "level", this._actionModel = {}, this.effectType = t, this._actionModel.actionType = Ge[t] || t, n && this.setLevel(n);
  }
  /**
   *
   * @description Sets the effect level for the action
   * @param {string | number} level - The strength of the effect
   * @protected
   */
  setLevel(t) {
    this._actionModel[this.LEVEL_NAME] = t;
    const n = this.createEffectQualifier(this.effectType, t);
    return this.addQualifier(n), this;
  }
}
function _t(e) {
  return e && (e.match(/^#/) ? `rgb:${e.substr(1)}` : e);
}
class hi extends A {
  constructor() {
    super(), this._actionModel = {}, this._actionModel.actionType = "vectorize";
  }
  /**
   * @description The number of colors. (Range: 2 to 30, Server default: 10)
   * @param {number | string} num
   * @return {this}
   */
  numOfColors(t) {
    return this._actionModel.numOfColors = t, this._numOfColors = t, this;
  }
  /**
   * @description The level of detail. Specify either a percentage of the original image (Range: 0.0 to 1.0) or an absolute number of pixels (Range: 0 to 1000). (Server default: 300)
   * @param {number | string} num
   * @return {this}
   */
  detailsLevel(t) {
    return this._actionModel.detailLevel = t, this._detailsLevel = t, this;
  }
  /**
   * @description The size of speckles to suppress. Specify either a percentage of the original image (Range: 0.0 to 1.0) or an absolute number of pixels (Range: 0 to 100, Server default: 2)
   * @param {number | string} num
   * @return {this}
   */
  despeckleLevel(t) {
    return this._actionModel.despeckleLevel = t, this._despeckleLevel = t, this;
  }
  /**
   * @description The corner threshold. Specify 100 for no smoothing (polygon corners), 0 for completely smooth corners. (Range: 0 to 100, Default: 25)
   * @param {number | string} num
   * @return {this}
   */
  cornersLevel(t) {
    return this._actionModel.cornersLevel = t, this._cornersLevel = t, this;
  }
  /**
   * @description The optimization value. Specify 100 for least optimization and the largest file. (Range: 0 to 100, Server default: 100).
   * @param {number} num
   * @return {this}
   */
  paths(t) {
    return this._actionModel.paths = t, this._paths = t, this;
  }
  prepareQualifiers() {
    let t = "vectorize";
    this._numOfColors && (t += `:${new v(`colors:${this._numOfColors}`).toString()}`), this._detailsLevel && (t += `:${new v(`detail:${this._detailsLevel}`).toString()}`), this._despeckleLevel && (t += `:${new v(`despeckle:${this._despeckleLevel}`).toString()}`), this._paths && (t += `:${new v(`paths:${this._paths}`).toString()}`), this._cornersLevel && (t += `:${new v(`corners:${this._cornersLevel}`).toString()}`), this.addQualifier(new p("e", t));
  }
  static fromJson(t) {
    const { actionType: n, paths: i, cornersLevel: s, despeckleLevel: a, detailLevel: u, numOfColors: f } = t, h = new this();
    return i && h.paths(i), s && h.cornersLevel(s), a && h.despeckleLevel(a), u && h.detailsLevel(u), f && h.numOfColors(f), h;
  }
}
class pi extends di {
  level(t) {
    return this._actionModel.level = t, this.setLevel(t);
  }
}
class gi extends A {
  constructor() {
    super(), this._actionModel = {}, this._actionModel.actionType = "assistColorblind", this.addQualifier(new p("e", new v("assist_colorblind")));
  }
  /**
   * @description Replaces problematic colors with colors that are easier to differentiate.
   * @return {this}
   */
  xray() {
    return this._actionModel.type = "xray", this.addQualifier(new p("e", new v(["assist_colorblind", "xray"]).setDelimiter(":")));
  }
  /**
   * @description Applies stripes of the specified intensity to help people with common color blind conditions to differentiate between colors that are similar for them.
   * @param {number | string} strength The intensity of the stripes. (Range: 1 to 100, Server default: 10)
   * @return {this}
   */
  stripesStrength(t) {
    return this._actionModel.type = "stripes", this._actionModel.stripesStrength = t, this.addQualifier(new p("e", new v(["assist_colorblind", t]).setDelimiter(":")));
  }
  static fromJson(t) {
    const { actionType: n, type: i, stripesStrength: s } = t, a = new this();
    return i === "xray" && a.xray(), i === "stripes" && s && a.stripesStrength(s), a;
  }
}
class _i extends pi {
  /**
   * @description The color to use for colorization. Specify HTML name or RGB hex code. (Server default: gray)
   * @param {string} color HTML name(red, green, etc.) or RGB hex code. (Server default: gray)
   * @return {this}
   */
  color(t) {
    return this._actionModel.color = t, this.addQualifier(new p("co", new v(_t(t))));
  }
  static fromJson(t) {
    const { actionType: n, level: i, color: s } = t, a = new this(n, i);
    return s && a.color(s), a;
  }
}
class mi extends A {
  constructor(t) {
    super(), this._actionModel = {}, this._squareSize = t, this._actionModel.actionType = "pixelate", this._actionModel.squareSize = t;
  }
  /**
   * @description Specifies the region to piexlate.
   * @param {NamedRegion} pixelateRegion
   */
  region(t) {
    return this._region = t, this._actionModel.region = { regionType: this._region.regionType }, this;
  }
  /**
   * @description Sets the squareSize of the pixelate effect.
   * @param {number | string} squareSize
   */
  squareSize(t) {
    return this._squareSize = t, this._actionModel.squareSize = t, this;
  }
  prepareQualifiers() {
    const t = this._squareSize ? `:${this._squareSize}` : "";
    "_region" in this ? (this._region.qualifiers.forEach((i) => this.addQualifier(i)), this._region.regionType === "custom" && this.addQualifier(new p("e", `pixelate_region${t}`)), this._region.regionType === "ocr_text" && (this.addQualifier(new p("e", `pixelate_region${t}`)), this.addQualifier(new p("g", "ocr_text"))), this._region.regionType === "faces" && this.addQualifier(new p("e", `pixelate_faces${t}`))) : this.addQualifier(new p("e", `pixelate${t}`));
  }
  static fromJson(t) {
    const { region: n, squareSize: i } = t, s = new this(i);
    return i && s.squareSize(i), n && n.regionType === "faces" && s.region(Fe()), n && n.regionType === "custom" && s.region(ri()), s;
  }
}
const vi = (e) => Ti(encodeURIComponent, bi, Ai)(e), yi = /[!'()*~_.-]/g, wi = {
  "!": "%21",
  "'": "%27",
  "(": "%28",
  ")": "%29",
  "*": "%2A",
  "~": "%7E",
  _: "%5F",
  ".": "%2E",
  "-": "%2D"
}, bi = (e) => e.replace(yi, (t) => {
  var n;
  return (n = wi[t]) !== null && n !== void 0 ? n : t;
}), Ai = (e) => e.replace(/%20/g, " "), Ti = (...e) => (t) => e.reduce((n, i) => i(n), t);
function Oi(e) {
  return new oi(e);
}
function Ei() {
  return new De("grayscale");
}
function Oe(e) {
  return new _i("colorize", e);
}
function Si() {
  return new hi();
}
function Mi() {
  return new gi();
}
function xi(e) {
  return new mi(e);
}
class Ci extends A {
  constructor(t) {
    super(), this._actionModel = {}, this.addQualifier(new p("b", new v(_t(t)).setDelimiter("_"))), this._actionModel.color = t, this._actionModel.actionType = "backgroundColor";
  }
  static fromJson(t) {
    const { color: n } = t;
    return new this(n);
  }
}
class Ee {
  constructor(t) {
    this.raw = t;
  }
  toString() {
    return this.raw;
  }
  toJson() {
    return { error: Qt(`unsupported action ${this.constructor.name}`) };
  }
}
function Li(e) {
  const t = e;
  return "error" in t && !!t.error;
}
function Ri() {
  return new O("ignore_aspect_ratio");
}
function ji() {
  return new O("lossy");
}
function Ii() {
  return new O("preserve_transparency");
}
function Pi(e) {
  return new O("progressive", e);
}
function $i() {
  return new O("region_relative");
}
function Fi() {
  return new O("relative");
}
class Bt extends v {
  constructor(t) {
    super(t), this.val = t;
  }
  getValue() {
    return this.val;
  }
}
class qe extends A {
  /**
   * @param {string} deliveryKey A generic Delivery Action Key (such as q, f, dn, etc.)
   * @param {string} deliveryType A Format Qualifiers for the action, such as Quality.auto()
   * @param {string} modelProperty internal model property of the action, for example quality uses `level` while dpr uses `density`
   * @see Visit {@link Actions.Delivery|Delivery} for an example
   */
  constructor(t, n, i) {
    super(), this._actionModel = {};
    let s;
    n instanceof Bt ? s = n.getValue() : s = n, this._actionModel.actionType = fi[t], this._actionModel[i] = s, this.addQualifier(new p(t, n));
  }
}
class Vi extends O {
  constructor(t) {
    super("progressive", t);
  }
}
class $t extends qe {
  constructor(t, n) {
    super(t, n, "formatType");
  }
  /**
   * @description Uses lossy compression when delivering animated GIF files.
   * @return {this}
   */
  lossy() {
    return this._actionModel.lossy = !0, this.addFlag(ji()), this;
  }
  /**
   * @description Uses progressive compression when delivering JPG file format.
   * @return {this}
   */
  progressive(t) {
    return t instanceof Vi ? (this._actionModel.progressive = { mode: t.getFlagValue() }, this.addFlag(t)) : (this._actionModel.progressive = { mode: t }, this.addFlag(Pi(t))), this;
  }
  /**
   * @description Ensures that images with a transparency channel are delivered in PNG format.
   */
  preserveTransparency() {
    return this._actionModel.preserveTransparency = !0, this.addFlag(Ii()), this;
  }
  static fromJson(t) {
    const { formatType: n, lossy: i, progressive: s, preserveTransparency: a } = t;
    let u;
    return n ? u = new this("f", n) : u = new this("f"), s && (s.mode ? u.progressive(s.mode) : u.progressive()), i && u.lossy(), a && u.preserveTransparency(), u;
  }
}
class J {
  constructor() {
    this.actions = [];
  }
  /**
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(t) {
    let n;
    if (typeof t == "string") {
      if (t.indexOf("/") >= 0)
        throw "addAction cannot accept a string with a forward slash in it - /, use .addTransformation() instead";
      n = new Ee(t);
    } else
      n = t;
    return this.actions.push(n), this;
  }
  /**
   * @description Allows the injection of a raw transformation as a string into the transformation, or a Transformation instance that was previously created
   * @param {string | SDK.Transformation} tx
   * @example
   * import {Transformation} from "@cloudinary/url-gen";
   *
   * const transformation = new Transformation();
   * transformation.addTransformation('w_100/w_200/w_300');
   * @return {this}
   */
  addTransformation(t) {
    return t instanceof J ? this.actions = this.actions.concat(t.actions) : this.actions.push(new Ee(t)), this;
  }
  /**
   * @return {string}
   */
  toString() {
    return this.actions.map((t) => t.toString()).filter((t) => t).join("/");
  }
  /**
   * @description Delivers an animated GIF.
   * @param {AnimatedAction} animatedAction
   * @return {this}
   */
  animated(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds a border around the image.
   * @param {Border} borderAction
   * @return {this}
   */
  border(t) {
    return this.addAction(t);
  }
  /**
   * @description Adjusts the shape of the delivered image. </br>
   * <b>Learn more:</b> {@link https://cloudinary.com/documentation/effects_and_artistic_enhancements#distort|Shape changes and distortion effects}
   * @param {IReshape} reshapeAction
   * @return {this}
   */
  reshape(t) {
    return this.addAction(t);
  }
  /**
   * @description Resize the asset using provided resize action
   * @param {ResizeSimpleAction} resizeAction
   * @return {this}
   */
  resize(t) {
    return this.addAction(t);
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(t) {
    return this.addAction(new $t("q", t)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(t) {
    return this.addAction(new $t("f", t)), this;
  }
  /**
   * @description Rounds the specified corners of an image.
   * @param roundCornersAction
   * @return {this}
   */
  roundCorners(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds an overlay over the base image.
   * @param {LayerAction} overlayAction
   * @return {this}
   */
  overlay(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds an underlay under the base image.
   * @param {LayerAction} underlayAction
   * @return {this}
   */
  underlay(t) {
    return t.setLayerType("u"), this.addAction(t);
  }
  /**
   * @description Defines an new user variable.
   * @param {VariableAction} variableAction
   * @return {this}
   */
  addVariable(t) {
    return this.addAction(t);
  }
  /**
   * @description Specifies a condition to be met before applying a transformation.
   * @param {ConditionalAction} conditionAction
   * @return {this}
   */
  conditional(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies a filter or an effect on an asset.
   * @param {SimpleEffectAction} effectAction
   * @return {this}
   */
  effect(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies adjustment effect on an asset.
   * @param action
   * @return {this}
   */
  adjust(t) {
    return this.addAction(t);
  }
  /**
   * @description Rotates the asset by the given angle.
   * @param {RotateAction} rotateAction
   * @return {this}
   */
  rotate(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies a pre-defined named transformation of the given name.
   * @param {NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies delivery action.
   * @param deliveryAction
   * @return {this}
   */
  delivery(t) {
    return this.addAction(t);
  }
  /**
   * @description Sets the color of the background.
   * @param {Qualifiers.Color} color
   * @return {this}
   */
  backgroundColor(t) {
    return this.addAction(new Ci(t));
  }
  /**
   * @description Adds a layer in a Photoshop document.
   * @param action
   * @return {this}
   */
  psdTools(t) {
    return this.addAction(t);
  }
  /**
   * @description Extracts an image or a page using an index, a range, or a name from a layered media asset.
   * @param action
   * @return {this}
   */
  extract(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds a flag as a separate action.
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(t) {
    const n = new A();
    let i = t;
    return typeof t == "string" && (i = new O(t)), n.addQualifier(i), this.addAction(n);
  }
  /**
   * @description Inject a custom function into the image transformation pipeline.
   * @return {this}
   */
  customFunction(t) {
    return this.addAction(t);
  }
  /**
   * Transcodes the video (or audio) to another format.
   * @param {Action} action
   * @return {this}
   */
  transcode(t) {
    return this.addAction(t);
  }
  /**
   * Applies the specified video edit action.
   *
   * @param {videoEditType} action
   * @return {this}
   */
  videoEdit(t) {
    return this.addAction(t);
  }
  toJson() {
    const t = [];
    for (const n of this.actions) {
      const i = n.toJson();
      if (Li(i))
        return i;
      t.push(i);
    }
    return { actions: t };
  }
}
function Se(e) {
  const t = e.toString();
  return t.match(/[A-Z]/gi) || t.length > 1 && t[0] === "0" ? t : !isNaN(parseFloat(t)) && t.indexOf(":") === -1 && t.indexOf(".") === -1 ? `${t}.0` : t;
}
class Qi extends v {
}
class ze extends A {
  /**
   * @param {string} cropType
   * @param {number | string} cropWidth The required width of a transformed asset.
   * @param {number | string} cropHeight The required height of a transformed asset.
   */
  constructor(t, n, i) {
    super(), this._actionModel = { dimensions: {} }, this._actionModel.actionType = li[t] || t, this.addQualifier(new p("c", t)), n && this.width(n), i && this.height(i);
  }
  /**
   * @description Sets the height of the resize
   * @param {string | number} x The height in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */
  height(t) {
    return this._actionModel.dimensions.height = t, this.addQualifier(new p("h", t));
  }
  /**
   * @description Sets the width of the resize
   * @param {string | number} x The width in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */
  width(t) {
    return this._actionModel.dimensions.width = t, this.addQualifier(new p("w", t));
  }
  /**
   * @description Sets the aspect ratio of the asset.
   * For a list of supported types see {@link Qualifiers.AspectRatio|
    * AspectRatio values}
   * @param {AspectRatioType|number|string} ratio The new aspect ratio, specified as a percentage or ratio.
   * @return {this}
   */
  aspectRatio(t) {
    if (t instanceof Qi)
      return this._actionModel.dimensions.aspectRatio = `${t}`, this.addQualifier(new p("ar", t));
    if (typeof t == "number" || typeof t == "string")
      return this._actionModel.dimensions.aspectRatio = Se(t), this.addQualifier(new p("ar", Se(t)));
    if (t instanceof O)
      return this._actionModel.dimensions.aspectRatio = `${t.qualifierValue}`, this.addFlag(t);
  }
  /**
   * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the containing image instead of the added layer.
   * @return {this}
   */
  relative() {
    return this._actionModel.relative = !0, this.addFlag(Fi());
  }
  /**
   * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the overlaid region
   * @return {this}
   */
  regionRelative() {
    return this._actionModel.regionRelative = !0, this.addFlag($i());
  }
  static fromJson(t) {
    const { actionType: n, dimensions: i, relative: s, regionRelative: a } = t, { aspectRatio: u, width: f, height: h } = i, l = Ve[n] || n, g = new this(l, f, h);
    return u && g.aspectRatio(u === "ignore_aspect_ratio" ? Ri() : u), s && g.relative(), a && g.regionRelative(), g;
  }
}
class mt extends p {
  /**
   * @param value, an array containing (GravityObject | AutoGravity | string) or a string;
   */
  constructor(t) {
    super("g", new v(t));
  }
}
class Ne extends mt {
  constructor() {
    super("auto");
  }
  /**
   * @description Autofocuses on objects, allowing their priority within the algorithm to be configured.
   * @param {AutoFocus} AutoFocusObjects
   */
  autoFocus(...t) {
    return this.addValue(t), this;
  }
}
class Ue extends mt {
  constructor(t) {
    super(t);
  }
  /**
   * @description Specifies the gravity to use if none of the other gravity objects are found.
   * @param {Qualifiers.Gravity.AutoGravity} val
   */
  fallbackGravity(t) {
    return this.addValue(t.qualifierValue), this;
  }
}
class Je extends mt {
  constructor(t) {
    super(t);
  }
}
function ki(e) {
  return new Je(e);
}
function He(...e) {
  const t = [...e];
  return new Ue(t);
}
function We() {
  return new Ne();
}
class U extends v {
  constructor(t) {
    super(), this.name = t;
  }
  toString() {
    return this.name;
  }
}
function Bi() {
  return new U("ocr_text");
}
function Gi(e) {
  return e && `${e}`.split(":")[0] === "auto";
}
function Di(e) {
  const t = Gt(e);
  return ["north", "center", "east", "west", "south", "north_west", "south_east", "south_west", "north_east"].includes(t);
}
function Gt(e) {
  return `${e}`.replace("g_", "");
}
function qi(e) {
  return {
    compass: Gt(e),
    gravityType: "direction"
  };
}
function zi(e) {
  return Gt(e) === "ocr_text";
}
function Ni() {
  return {
    gravityType: "ocr"
  };
}
function Ui(e) {
  return `${e.qualifierValue}`.split(":")[0] === "auto";
}
function Ji(e) {
  const n = e.toString().split("_"), i = {
    object: n[0]
  };
  return n.length > 1 && (n[1] === "avoid" ? i.avoid = !0 : i.weight = +n[1]), i;
}
function Ye(e) {
  let t;
  const n = e === "auto" ? new Ne() : e;
  return `${e}`.startsWith("auto:") ? t = `${e}`.split(":").filter((s) => s !== "auto") : t = n.qualifierValue.values.filter((s) => s !== "auto"), {
    gravityType: "auto",
    autoFocus: t.map(Ji)
  };
}
function Hi(e) {
  const t = `${e}`.split(":").includes("auto"), n = e.qualifierValue.values, s = {
    gravityType: "object",
    focusOnObjects: (t ? n.slice(0, n.length - 1) : n).map((a) => `${a}`)
  };
  if (t) {
    const a = n[n.length - 1].values.slice(1), u = We().autoFocus(...a);
    s.fallbackGravity = Ye(u);
  }
  return s;
}
function Wi(e) {
  const n = e.split(":").map((i) => new U(i));
  return new Ue(n);
}
function Yi(e) {
  return Di(e) ? qi(e) : zi(e) ? Ni() : Gi(e) || Ui(e) ? Ye(e) : Hi(typeof e == "string" ? Wi(e) : e);
}
class Dt extends v {
  constructor(t, n) {
    super(), this._weight = n, this.focusOn = t, this.shouldAvoid = !1;
  }
  /**
   * @summary qualifier
   * @description Specifies the object to focus on automatically
   * Accepts an AutoFocusObject (which is just a wrapper for a FocusOn object, but with extra method: avoid, weight)
   * @param {Qualifiers.FocusOn} obj The object to focus on.
   * @param {number} weight
   */
  static focusOn(t, n) {
    const i = t instanceof U ? t : new U(t);
    return new Dt(i, n);
  }
  shouldAddWeight() {
    return typeof this._weight == "number" || typeof this._weight == "string" || this.shouldAvoid;
  }
  /**
   * @summary qualifier
   * @desc Get the name of the of the object
   */
  getName() {
    return this.focusOn.name;
  }
  /**
   * @summary qualifier
   * @desc Get the weight for the object
   */
  getWeight() {
    return this.shouldAvoid ? "avoid" : this._weight;
  }
  /**
   * @summary qualifier
   * @desc Return the string representation of this QualifierValue
   */
  toString() {
    return this.shouldAddWeight() ? `${this.getName()}_${this.getWeight()}` : `${this.getName()}`;
  }
  /**
   * @summary qualifier
   * @description Sets the importance level of the object within the automatic gravity algorithm
   * @param {numebr} w The focus weight for the object
   * @return {this}
   */
  weight(t) {
    return this._weight = t, this;
  }
  /**
   * @summary qualifier
   * @description Attempts to avoid the detected object in the image
   * @return {this}
   */
  avoid() {
    return this.shouldAvoid = !0, this;
  }
}
class Ke extends v {
  constructor(t) {
    super(), this.val = t;
  }
  toString() {
    return this.val;
  }
}
function Ki(e) {
  return e.gravityType === "direction";
}
function Xi(e) {
  return e.gravityType === "ocr";
}
function Zi(e) {
  return e.gravityType === "auto";
}
function to(e) {
  const { object: t, weight: n, avoid: i } = e, s = new Dt(new U(t));
  return (n || n === 0) && s.weight(n), i && s.avoid(), s;
}
function Xe(e) {
  const n = (e.autoFocus || []).map(to);
  return We().autoFocus(...n);
}
function eo(e) {
  const t = (e.focusOnObjects || []).map((i) => new U(i)), n = He(...t);
  if (e.fallbackGravity) {
    const i = Xe(e.fallbackGravity);
    n.fallbackGravity(i);
  }
  return n;
}
function no(e) {
  return Ki(e) ? new Je(new Ke(e.compass)) : Xi(e) ? He(Bi()) : Zi(e) ? Xe(e) : eo(e);
}
class qt extends ze {
  /**
   * @description Which part of the original image to include.
   * @param {Qualifiers.Gravity} gravity
   */
  gravity(t) {
    this._actionModel.gravity = Yi(t);
    const n = typeof t == "string" ? new p("g", t) : t;
    return this.addQualifier(n);
  }
  static fromJson(t) {
    const n = super.fromJson.apply(this, [t]);
    return t.gravity && n.gravity(no(t.gravity)), n;
  }
}
class rt extends p {
  constructor(t) {
    super("b"), t && this.addValue(t);
  }
}
const Ze = 100, ro = 0;
class io extends rt {
  /**
   * @description Sets the intensity of the blur.
   * @param {number} value - The intensity of the blur.
   */
  intensity(t) {
    return this.intensityLevel = t, this;
  }
  /**
   * @description Sets the brightness of the background.
   * @param {number} value - The brightness of the background.
   */
  brightness(t) {
    return this.brightnessLevel = t, this;
  }
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function
   */
  toString() {
    const t = this.intensityLevel !== void 0 ? `:${this.intensityLevel}` : "", n = this.brightnessLevel !== void 0 ? this.intensityLevel !== void 0 ? `:${this.brightnessLevel}` : `:${Ze}:${this.brightnessLevel}` : "";
    return `b_blurred${t}${n}`;
  }
}
var tn = io;
class zt extends rt {
  constructor() {
    super(), this._palette = [];
  }
  /**
   * @description Selects the strongest contrasting color to use for padding.
   * @return {this}
   */
  contrast() {
    return this._contrast = !0, this;
  }
  /**
   * @description Defines the custom colors to use when resizing using content-aware padding.
   * @param {...string} colors One or more colors - Example: palette('green', 'red', blue')
   * @return {this}
   */
  palette(...t) {
    return this._palette = t.map((n) => _t(n)), this;
  }
}
class en extends zt {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:border
    ${this._contrast ? "_contrast" : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class nn extends zt {
  /**
   *
   * @description Sets the number of predominant colors to use (2 or 4).
   * @param {number} num
   * @return {this}
   */
  gradientColors(t) {
    return this._gradientColors = t, this;
  }
  /**
   * @description Sets the direction for a background gradient fade effect.
   * @param {Qualifiers.GradientDirection | GradientDirectionType | string} direction Use one of these functions
   * provided by {@link Qualifiers.GradientDirection|GradientDirection}
   * @return {this}
   */
  gradientDirection(t) {
    return this._gradientDirection = t, this;
  }
}
class rn extends nn {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:border_gradient
    ${this._contrast ? "_contrast" : ""}
    ${this._gradientColors ? `:${this._gradientColors}` : ""}
    ${this._gradientDirection ? `:${this._gradientDirection}` : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class on extends nn {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:predominant_gradient
    ${this._contrast ? "_contrast" : ""}
    ${this._gradientColors ? `:${this._gradientColors}` : ""}
    ${this._gradientDirection ? `:${this._gradientDirection}` : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class sn extends zt {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:predominant
    ${this._contrast ? "_contrast" : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class an extends rt {
  constructor() {
    super("gen_fill"), this._backgroundType = "generativeFill";
  }
  prompt(t) {
    try {
      this._prompt = decodeURIComponent(t);
    } catch {
      this._prompt = t;
    }
    return this;
  }
  getPrompt() {
    return this._prompt;
  }
  getBackgroundType() {
    return this._backgroundType;
  }
  /**
   * @description
   * Override the toString() function to explicitly stringify the qualifier.
   */
  toString() {
    return `b_gen_fill${this._prompt ? `:prompt_${vi(this._prompt)}` : ""}`;
  }
}
function cn(e) {
  return `${e}`.replace("b_", "");
}
function oo() {
  return { backgroundType: "auto" };
}
function so(e) {
  const { intensityLevel: t, brightnessLevel: n } = e, i = {
    backgroundType: "blurred"
  };
  return (t || t === 0) && (i.intensity = t), (n || n === 0) && (i.brightness = n), i;
}
function Nt(e) {
  const t = e._contrast, n = e._palette, i = {
    backgroundType: ""
  };
  return t && (i.contrast = !0), n && (i.palette = n), i;
}
function ao(e) {
  return Object.assign(Object.assign({}, Nt(e)), { backgroundType: "border" });
}
function un(e) {
  const t = e._gradientColors, n = `${e._gradientDirection}`, i = Nt(e);
  return t && (i.gradientColors = t), n && (i.gradientDirection = n), i;
}
function co(e) {
  return Object.assign(Object.assign({}, un(e)), { backgroundType: "borderGradient" });
}
function uo(e) {
  return {
    backgroundType: "color",
    color: cn(e)
  };
}
function lo(e) {
  return Object.assign(Object.assign({}, Nt(e)), { backgroundType: "predominant" });
}
function fo(e) {
  return Object.assign(Object.assign({}, un(e)), { backgroundType: "predominantGradient" });
}
function ho(e) {
  return Object.assign({ backgroundType: e.getBackgroundType() }, e.getPrompt() ? { prompt: e.getPrompt() } : {});
}
function po(e) {
  return cn(e) === "auto" ? oo() : e instanceof tn ? so(e) : e instanceof en ? ao(e) : e instanceof rn ? co(e) : e instanceof sn ? lo(e) : e instanceof on ? fo(e) : e instanceof an ? ho(e) : uo(e);
}
function go() {
  return new Bt("svg");
}
function Ut() {
  return new Bt("auto");
}
function ln() {
  return new en();
}
function fn() {
  return new rt("auto");
}
function dn() {
  return new rn();
}
function hn() {
  return new on();
}
function pn() {
  return new sn();
}
function gn(e) {
  return new rt(_t(e));
}
function _o() {
  return new tn();
}
function _n() {
  return new an();
}
const mn = {
  auto: fn,
  border: ln,
  borderGradient: dn,
  predominantGradient: hn,
  predominant: pn,
  color: gn,
  blurred: _o,
  generativeFill: _n
};
function mo(e) {
  const { brightness: t, intensity: n } = e, i = mn.blurred();
  return i.brightness(t ?? ro), i.intensity(n ?? Ze), i;
}
function Me(e, t) {
  const { gradientColors: n, gradientDirection: i, contrast: s, palette: a } = t;
  return s && e.contrast(), a && e.palette(...a), n && e.gradientColors(+n), i && e.gradientDirection(i), e;
}
function xe(e, t) {
  const { contrast: n, palette: i } = t;
  return n && e.contrast(), i && e.palette(...i), e;
}
function vo(e, t) {
  const { prompt: n } = t;
  return n && e.prompt(n), e;
}
function yo(e) {
  const { backgroundType: t } = e;
  switch (t) {
    case "auto":
      return fn();
    case "blurred":
      return mo(e);
    case "border":
      return xe(ln(), e);
    case "borderGradient":
      return Me(dn(), e);
    case "predominant":
      return xe(pn(), e);
    case "predominantGradient":
      return Me(hn(), e);
    case "generativeFill":
      return vo(_n(), e);
    default:
      return gn(e.color);
  }
}
class wo extends qt {
  /**
   * @description Sets the background.
   * @param {Qualifiers.Background} backgroundQualifier Defines the background color to use instead of
   * transparent background areas or when resizing with padding.
   */
  background(t) {
    return this._actionModel.background = po(t), this.addQualifier(t);
  }
  /**
   * @description Horizontal position for custom-coordinates based padding.
   * @param {number} x The x position.
   */
  offsetX(t) {
    return this._actionModel.x = t, this.addQualifier(new p("x", t));
  }
  /**
   * @description Vertical position for custom-coordinates based padding
   * @param {number} y The y position.
   */
  offsetY(t) {
    return this._actionModel.y = t, this.addQualifier(new p("y", t));
  }
  static fromJson(t) {
    const n = super.fromJson.apply(this, [t]);
    return t.background && n.background(yo(t.background)), t.x && n.offsetX(t.x), t.y && n.offsetY(t.y), t.zoom && n.zoom(t.zoom), n;
  }
}
class bo extends ze {
  /**
   * @description Changes the aspect ratio of an image while retaining all important content and avoiding unnatural
   * distortions.
   * @return {this}
   */
  liquidRescaling() {
    return this.addQualifier(new mt("liquid"));
  }
}
class Ao extends qt {
  /**
   * @description Horizontal position for custom-coordinates based cropping.
   * @param {number} x The x position.
   */
  x(t) {
    return this._actionModel.x = t, this.addQualifier(new p("x", t));
  }
  /**
   * @description Vertical position for custom-coordinates based cropping
   * @param {number} y The y position.
   */
  y(t) {
    return this._actionModel.y = t, this.addQualifier(new p("y", t));
  }
  /**
   * @description Controls how much of the original image surrounding the face to keep when using either the 'crop' or 'thumb' cropping modes with face detection.
   * @param {number | string} z The zoom factor. (Default: 1.0)
   */
  zoom(t) {
    return this._actionModel.zoom = t, this.addQualifier(new p("z", t));
  }
  static fromJson(t) {
    const n = super.fromJson.apply(this, [t]);
    return t.x && n.x(t.x), t.y && n.y(t.y), t.zoom && n.zoom(t.zoom), n;
  }
}
class To extends qt {
  /**
   * @description Absolute X position when used with Gravity.xyCenter {@link Qualifiers.Gravity.GravityQualifier}}
   * @param {number} x The x position.
   */
  x(t) {
    return this._actionModel.x = t, this.addQualifier(new p("x", t));
  }
  /**
   * @description Absolute Y position when used with Gravity.xyCenter {@link Qualifiers.Gravity.GravityQualifier}}
   * @param {number} y The y position.
   */
  y(t) {
    return this._actionModel.y = t, this.addQualifier(new p("y", t));
  }
  static fromJson(t) {
    const n = super.fromJson.apply(this, [t]);
    return t.x && n.x(t.x), t.y && n.y(t.y), n;
  }
}
function Oo(e, t) {
  return new bo("scale", e, t);
}
function Eo(e, t) {
  return new Ao("crop", e, t);
}
function So(e, t) {
  return new To("fill", e, t);
}
function Mo(e, t) {
  return new wo("pad", e, t);
}
class xo extends qe {
  /**
   * @param {Qualifiers.Quality} qualityValue a Quality value
   */
  constructor(t) {
    super("q", t.toString(), "level");
  }
  /**
   * Selet the Chroma sub sampling</br>
   * <b>Learn more</b>: {@link https://cloudinary.com/documentation/image_optimization#toggle_chroma_subsampling|Toggling chroma subsampling}
   * @param {420 | 444 | number} type The chroma sub sampling type
   */
  chromaSubSampling(t) {
    this._actionModel.chromaSubSampling = Be[t];
    const n = new v([this._actionModel.level, t]);
    return n.setDelimiter(":"), this.addQualifier(new p("q", n));
  }
  /**
   * Controls the final quality by setting a maximum quantization percentage
   * @param {number} val
   */
  quantization(t) {
    this._actionModel.quantization = t;
    const n = new v([this._actionModel.level, `qmax_${t}`]).setDelimiter(":");
    return this.addQualifier(new p("q", n));
  }
  static fromJson(t) {
    const { level: n, chromaSubSampling: i, quantization: s } = t, a = ke[n] || n, u = new this(a);
    if (i) {
      const f = ui[i.toUpperCase()];
      f && u.chromaSubSampling(+f);
    }
    return s && u.quantization(s), u;
  }
}
function vt(e) {
  return new $t("f", e);
}
function yt(e) {
  return new xo(e);
}
function Co() {
  return new Ke("north_east");
}
Oe(70).color("black"), Oe(40).color("white"), Ei(), Mi();
var Lo = new J().effect(Si()).delivery(yt("auto")).delivery(vt(go())), Ro = new J().effect(xi()).delivery(yt("auto")).delivery(vt(Ut())), jo = new J().effect(Oi(2e3)).delivery(yt("auto")).delivery(vt(Ut())), Io = new J().resize(Mo("iw_div_2").aspectRatio(1).background(mn.auto())).resize(Eo(1, 1).gravity(ki(Co()))).resize(So().height("ih").width("iw")).delivery(yt("auto")).delivery(vt(Ut())), Ce = {
  vectorize: Lo,
  pixelate: Ro,
  blur: jo,
  "predominant-color": Io
}, Le = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", Re = {
  flv: "x-flv",
  "3gp": "3gpp",
  mov: "quicktime",
  mpg: "mpeg",
  avi: "x-msvideo",
  wmv: "x-ms-wmv",
  ogv: "ogg",
  webm: "webm",
  mp4: "mp4"
}, je = "?_a=", Po = (
  /** @class */
  function() {
    function e(t, n, i, s, a, u, f) {
      var h = this;
      this.mimeType = "video", this.mimeSubTypes = Re, this.videoElement = t, this.originalVideo = n, this.videoOptions = f, this.htmlPluginState = { cleanupCallbacks: [], pluginEventSubscription: [] };
      var l = P(n);
      dt(t, n, s, this.htmlPluginState).then(function() {
        h.htmlPluginState.pluginEventSubscription.forEach(function(g) {
          g();
        }), h.setVideoAttributes(a, u), h.handleSourceToVideo(l, i);
      });
    }
    return e.prototype.handleSourceToVideo = function(t, n) {
      var i = this;
      if (n)
        this.generateUserSources(t, n);
      else {
        var s = ["webm", "mp4", "ogv"];
        s.forEach(function(a) {
          i.appendSourceTag(P(t), a);
        });
      }
    }, e.prototype.generateUserSources = function(t, n) {
      var i = this;
      n.map(function(s) {
        var a = s.type, u = s.codecs, f = s.transcode;
        return i.appendSourceTag(P(t).transcode(f), a, i.buildMimeType(a, u));
      });
    }, e.prototype.appendSourceTag = function(t, n, i) {
      var s, a = document.createElement("source"), u = (s = this.videoOptions) === null || s === void 0 ? void 0 : s.useFetchFormat;
      u && t.format(n);
      var f = t.toURL(), h = f.split(je), l = h[1] ? "".concat(je).concat(h[1]) : "", g = u ? "" : ".".concat(n);
      a.src = "".concat(h[0]).concat(g).concat(l), a.type = i || "video/".concat(Re[n] || n), this.videoElement.appendChild(a);
    }, e.prototype.buildMimeType = function(t, n) {
      var i = "".concat(this.mimeType, "/").concat(this.mimeSubTypes[t] || t);
      return n && (i += "; codecs=" + (Array.isArray(n) ? n.join(", ") : n)), i;
    }, e.prototype.setVideoAttributes = function(t, n) {
      var i;
      if (t === void 0 && (t = {}), n === "auto") {
        var s = P(this.originalVideo);
        t.poster = s.quality("auto").format("jpg").addTransformation("so_auto").toURL();
      } else n && (t.poster = (i = n.toURL) === null || i === void 0 ? void 0 : i.call(n));
      for (var a = 0, u = Object.entries(t); a < u.length; a++) {
        var f = u[a], h = f[0], l = f[1];
        l && this.videoElement.setAttribute(h, h === "poster" ? l : "");
      }
    }, e.prototype.update = function(t, n, i, s, a) {
      var u = this;
      if (t !== this.originalVideo) {
        for (var f = this.videoElement.getElementsByTagName("SOURCE"); f[0]; )
          f[0].parentNode.removeChild(f[0]);
        dt(this.videoElement, t, i, this.htmlPluginState).then(function() {
          u.setVideoAttributes(s, a), u.handleSourceToVideo(t, n), u.videoElement.load();
        });
      }
    }, e;
  }()
), $o = "Expected a function", Ie = NaN, Fo = "[object Symbol]", Vo = /^\s+|\s+$/g, Qo = /^[-+]0x[0-9a-f]+$/i, ko = /^0b[01]+$/i, Bo = /^0o[0-7]+$/i, Go = parseInt, Do = typeof I == "object" && I && I.Object === Object && I, qo = typeof self == "object" && self && self.Object === Object && self, zo = Do || qo || Function("return this")(), No = Object.prototype, Uo = No.toString, Jo = Math.max, Ho = Math.min, jt = function() {
  return zo.Date.now();
};
function Wo(e, t, n) {
  var i, s, a, u, f, h, l = 0, g = !1, T = !1, L = !0;
  if (typeof e != "function")
    throw new TypeError($o);
  t = Pe(t) || 0, Ft(n) && (g = !!n.leading, T = "maxWait" in n, a = T ? Jo(Pe(n.maxWait) || 0, t) : a, L = "trailing" in n ? !!n.trailing : L);
  function k(m) {
    var E = i, R = s;
    return i = s = void 0, l = m, u = e.apply(R, E), u;
  }
  function H(m) {
    return l = m, f = setTimeout(S, t), g ? k(m) : u;
  }
  function it(m) {
    var E = m - h, R = m - l, X = t - E;
    return T ? Ho(X, a - R) : X;
  }
  function W(m) {
    var E = m - h, R = m - l;
    return h === void 0 || E >= t || E < 0 || T && R >= a;
  }
  function S() {
    var m = jt();
    if (W(m))
      return Y(m);
    f = setTimeout(S, it(m));
  }
  function Y(m) {
    return f = void 0, L && i ? k(m) : (i = s = void 0, u);
  }
  function ot() {
    f !== void 0 && clearTimeout(f), l = 0, i = h = s = f = void 0;
  }
  function K() {
    return f === void 0 ? u : Y(jt());
  }
  function B() {
    var m = jt(), E = W(m);
    if (i = arguments, s = this, h = m, E) {
      if (f === void 0)
        return H(h);
      if (T)
        return f = setTimeout(S, t), k(h);
    }
    return f === void 0 && (f = setTimeout(S, t)), u;
  }
  return B.cancel = ot, B.flush = K, B;
}
function Ft(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function Yo(e) {
  return !!e && typeof e == "object";
}
function Ko(e) {
  return typeof e == "symbol" || Yo(e) && Uo.call(e) == Fo;
}
function Pe(e) {
  if (typeof e == "number")
    return e;
  if (Ko(e))
    return Ie;
  if (Ft(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Ft(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(Vo, "");
  var n = ko.test(e);
  return n || Bo.test(e) ? Go(e.slice(2), n ? 2 : 8) : Qo.test(e) ? Ie : +e;
}
var Xo = Wo;
function Zo(e) {
  return typeof e == "number";
}
function wt() {
  return typeof window < "u";
}
function vn(e) {
  return e instanceof HTMLImageElement;
}
var ts = {
  accessibility: !1,
  lazyload: !1,
  placeholder: !1,
  responsive: !1
}, es = function(e) {
  return e.replace("bound ", "").replace("Plugin", "");
}, ns = function(e, t) {
  e === void 0 && (e = []);
  var n = e.reduce(function(i, s) {
    var a, u = s.name;
    return et(et({}, i), (a = {}, a[es(u)] = !0, a));
  }, ts);
  return n[t];
};
function fs(e) {
  var t = e === void 0 ? {} : e, n = t.steps;
  return rs.bind(null, n);
}
function rs(e, t, n, i, s, a) {
  if (!wt())
    return !0;
  if (vn(t))
    return new Promise(function(u) {
      i.cleanupCallbacks.push(function() {
        window.removeEventListener("resize", l), u("canceled");
      });
      var f = ht(s, { responsive: !0 });
      n.addAction(new A().setActionTag("responsive"));
      var h = !ns(a, "placeholder");
      h ? $e(e, t, n, f) : yn(e, t, n);
      var l;
      i.pluginEventSubscription.push(function() {
        window.addEventListener("resize", l = Xo(function() {
          $e(e, t, n, f);
        }, 100));
      }), u({ responsive: !0 });
    });
}
function $e(e, t, n, i) {
  yn(e, t, n), t.src = n.toURL(i);
}
function yn(e, t, n) {
  var i = t.parentElement.clientWidth;
  if (Zo(e)) {
    var s = e;
    i = Math.ceil(i / s) * s;
  } else Array.isArray(e) && (i = e.reduce(function(a, u) {
    return Math.abs(u - i) < Math.abs(a - i) ? u : a;
  }));
  n.transformation.actions.forEach(function(a, u) {
    a instanceof A && a.getActionTag() === "responsive" && (n.transformation.actions[u] = Oo(i).setActionTag("responsive"));
  });
}
function ds(e) {
  var t = {}, n = t.rootMargin, i = n === void 0 ? "0px" : n, s = t.threshold, a = s === void 0 ? 0.1 : s;
  return is.bind(null, i, a);
}
function is(e, t, n, i, s, a) {
  return e === void 0 && (e = "0px"), t === void 0 && (t = 0.1), wt() ? new Promise(function(u) {
    var f = function() {
      return u({ lazyload: !0 });
    }, h = ss(n, f, e, t);
    s.cleanupCallbacks.push(function() {
      h(), u("canceled");
    });
  }) : !1;
}
function os() {
  return window && "IntersectionObserver" in window;
}
function ss(e, t, n, i) {
  try {
    if (!os())
      return t(), function() {
      };
    var s = new IntersectionObserver(function(a) {
      a.forEach(function(u) {
        u.isIntersecting && (s.unobserve(u.target), t());
      });
    }, { rootMargin: n, threshold: i });
    return s.observe(e), function() {
      e && s.observe(e);
    };
  } catch {
    t();
  }
}
function hs(e) {
  var t = e === void 0 ? {} : e, n = t.mode, i = n === void 0 ? "vectorize" : n;
  return as.bind(null, i);
}
function as(e, t, n, i, s, a) {
  Ce[e] || (e = "vectorize");
  var u = Ce[e].actions, f = P(n);
  if (u.forEach(function(l) {
    f.addAction(l);
  }), !wt())
    return n.transformation = f.transformation, !0;
  if (vn(t)) {
    f.transformation.actions.forEach(function(l, g) {
      l instanceof A && l.getActionTag() === "responsive" && delete f.transformation.actions[g];
    });
    var h = ht(s, { placeholder: !0 });
    return t.src = f.toURL(h), t.onerror = function() {
      t.src = Le;
    }, new Promise(function(l) {
      t.onload = function() {
        l();
      };
    }).then(function() {
      return new Promise(function(l) {
        i.cleanupCallbacks.push(function() {
          t.src = Le, l("canceled");
        });
        var g = new Image();
        g.src = n.toURL(h), g.onload = function() {
          l({ placeholder: !0 });
        }, g.onerror = function() {
          l({ placeholder: !0 });
        };
      });
    });
  }
}
function cs(e, t, n) {
  var i = P(t);
  if (e)
    for (var s = 0; s < e.length; s++) {
      var a = e[s](null, i);
      if (!a)
        break;
    }
  return i.toURL(n ? { trackedAnalytics: n } : null);
}
function pt(e) {
  e.cleanupCallbacks.forEach(function(t) {
    t();
  });
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var Vt = function(e, t) {
  return Vt = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, i) {
    n.__proto__ = i;
  } || function(n, i) {
    for (var s in i) i.hasOwnProperty(s) && (n[s] = i[s]);
  }, Vt(e, t);
};
function wn(e, t) {
  Vt(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var nt = function() {
  return nt = Object.assign || function(t) {
    for (var n, i = 1, s = arguments.length; i < s; i++) {
      n = arguments[i];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, nt.apply(this, arguments);
};
function bn(e, t) {
  var n = {};
  for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, i = Object.getOwnPropertySymbols(e); s < i.length; s++)
      t.indexOf(i[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[s]) && (n[i[s]] = e[i[s]]);
  return n;
}
var It = {
  sdkSemver: "1.14.1",
  techVersion: N.version,
  sdkCode: "J"
}, ps = (
  /** @class */
  function(e) {
    wn(t, e);
    function t(n) {
      var i = e.call(this, n) || this;
      return i.imageRef = N.createRef(), i;
    }
    return t.prototype.componentDidMount = function() {
      this.htmlLayerInstance = new Yr(this.imageRef.current, this.props.cldImg, this.props.plugins, It);
    }, t.prototype.componentDidUpdate = function() {
      pt(this.htmlLayerInstance.htmlPluginState), this.htmlLayerInstance.update(this.props.cldImg, this.props.plugins, It);
    }, t.prototype.componentWillUnmount = function() {
      pt(this.htmlLayerInstance.htmlPluginState), this.htmlLayerInstance.unmount();
    }, t.prototype.render = function() {
      var n = this.props;
      n.cldImg, n.plugins;
      var i = bn(n, ["cldImg", "plugins"]);
      if (wt())
        return N.createElement("img", nt({ suppressHydrationWarning: !0 }, i, { ref: this.imageRef }));
      var s = cs(this.props.plugins, this.props.cldImg, It);
      return N.createElement("img", nt({}, i, { src: s }));
    }, t;
  }(N.Component)
), us = ["controls", "loop", "muted", "poster", "preload", "autoplay", "playsinline"], gs = (
  /** @class */
  function(e) {
    wn(t, e);
    function t(n) {
      var i = e.call(this, n) || this;
      return i.videoRef = Ur(), i.attachRef = i.attachRef.bind(i), i;
    }
    return t.prototype.componentDidMount = function() {
      this.htmlVideoLayerInstance = new Po(this.videoRef && this.videoRef.current, this.props.cldVid, this.props.sources, this.props.plugins, this.getVideoAttributes(), this.props.cldPoster, {
        useFetchFormat: this.props.useFetchFormat
      });
    }, t.prototype.componentDidUpdate = function() {
      pt(this.htmlVideoLayerInstance.htmlPluginState), this.htmlVideoLayerInstance.update(this.props.cldVid, this.props.sources, this.props.plugins, this.getVideoAttributes(), this.props.cldPoster);
    }, t.prototype.componentWillUnmount = function() {
      pt(this.htmlVideoLayerInstance.htmlPluginState);
    }, t.prototype.getVideoAttributes = function() {
      var n = this, i = {};
      return us.forEach(function(s) {
        s in n.props && (i[s] = n.props[s]);
      }), i;
    }, t.prototype.attachRef = function(n) {
      this.videoRef.current = n;
      var i = this.props.innerRef;
      i && (i instanceof Function ? i(n) : i.current = n);
    }, t.prototype.render = function() {
      var n = this.props;
      n.cldVid, n.cldPoster, n.plugins, n.sources, n.innerRef, n.useFetchFormat;
      var i = bn(n, ["cldVid", "cldPoster", "plugins", "sources", "innerRef", "useFetchFormat"]);
      return N.createElement("video", nt({}, i, { ref: this.attachRef }));
    }, t;
  }(Jr)
);
export {
  ps as A,
  gs as a,
  ds as l,
  hs as p,
  fs as r
};
